import _extends from "@babel/runtime/helpers/esm/extends";
import _objectWithoutProperties from "@babel/runtime/helpers/esm/objectWithoutProperties";
var _excluded = ["color", "width", "title"];
import React from 'react';
import Svg from '../Svg';

var Facebook = function Facebook(_ref) {
  var _ref$color = _ref.color,
      color = _ref$color === void 0 ? '#6F768F' : _ref$color,
      _ref$width = _ref.width,
      width = _ref$width === void 0 ? '1.2rem' : _ref$width,
      _ref$title = _ref.title,
      title = _ref$title === void 0 ? 'Facebook icon' : _ref$title,
      rest = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement(Svg, _extends({
    title: title,
    width: width,
    viewBox: "0 0 12 24",
    fill: "none"
  }, rest), /*#__PURE__*/React.createElement("path", {
    d: "M12.0001 5.14335H9.68584C8.76355 5.14335 8.57155 5.5222 8.57155 6.47706V8.57192H12.0001L11.6418 12.0005H8.57155V24.0005H3.42869V12.0005H0.00012207V8.57192H3.42869V4.61535C3.42869 1.58277 5.02469 0.000488281 8.62126 0.000488281H12.0001V5.14335Z",
    fill: color
  }));
};

export default Facebook;